import { Form, Col, Row} from 'react-bootstrap';
import {useEffect, useReducer, useState, useRef } from "react";

const DatatableDropdownEntryField = ({label, handleChange, values, idKey, textKey, defaultItem,unique}) => {
    const handleKeyPress = (e) => {
        //console.log("KEYPRESS");
        //console.log(e.nativeEvent);
        if(e.nativeEvent.code === 'Enter'){
            e.preventDefault();
        }
    }

    

    return (
        <Form.Group as={Row} controlId={"form_rows"+unique} >
            <Col className="d-flex align-items-center  fit-content">
                <Form.Label className="datatable-filter-label flex-lg-shrink-0 no-shrink">{label}</Form.Label>
                <Form.Select
                    name="rows"
                    onChange={handleChange}
                    className="ms-2 me-2 fit-content"
                >
                    <option key={"rowsOption_"+defaultItem.id} value={defaultItem.id} /*selected={currentLength == v ? true : false}*/>{defaultItem.text}</option>
                    {
                        values.map((v) => 
                            <option key={"rowsOption_" + v[idKey]} value={v[idKey]} title={v[textKey]} /*selected={currentLength == v ? true : false}*/>{v[textKey]}</option>
                        )
                    }
                </Form.Select>
            </Col>
        </Form.Group>
    )
}

export default DatatableDropdownEntryField;